import type { ModuleManifest } from '../types';

/** Admin dashboard SPA — one lazy chunk mounted at /admin/*. */
export const adminModule: ModuleManifest = {
  id: 'admin',
  routes: [
    { path: '/admin/*', load: () => import('./AdminApp') },
  ],
};
